export default "__VITE_ASSET__0971a81e__"